<template>
    <div class="main" ref="scrollMain">
        <div class="wrapper">
            <div class="article-block article-block1">
                <div class="quotes">
                    <span class="text">
                        В&nbsp;каждое путешествие я&nbsp;собираюсь с&nbsp;чувством, что меня ждет что-то новое и&nbsp;интересное. Вот и&nbsp;на&nbsp;этот раз поездка получилась насыщенной и&nbsp;познавательной
                    </span>
                </div>
                <div class="article-main">
                    <div class="left animate-block">
                        <div class="img img1">
                            <img src="static/img/main/article1/front-lem.jpg" alt="">
                        </div>
                        <div class="img img2 delay3">
                            <img src="static/img/main/article1/back-lem.jpg" alt="">
                        </div>
                        <div class="img img3 delay6"></div>
                    </div>
                    <div class="right">
                        <div class="info">
                            <h3 class="head">
                                Солнечная бодрость Сицилии
                            </h3>
                            <span class="desc">
                                Сицилия&nbsp;&mdash; яркий и&nbsp;солнечный остров, омываемый тремя морями.
                                Смотрите видео о&nbsp;том, как природа этого острова зовет к&nbsp;приключениям!
                            </span>
                            <router-link to="/article1" class="btn" @click.native="gaEvents('main','click','go to longread 1')">
                                Cмотреть
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 87.2 65.2" style="enable-background:new 0 0 87.2 65.2;" xml:space="preserve">
                                    <path class="st0" d="M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2
                                        l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2
                                        c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"/>
                                </svg>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="article-block article-block2">
                <div class="quotes-img animate-img">
                    <img src="static/img/main/article2/img1.jpg" alt="">
                </div>
                <div class="quotes">
                    <span class="text">
                        Почти все свое детство я&nbsp;провела в&nbsp;Крыму у&nbsp;бабушки. Часто я&nbsp;помогала ей&nbsp;собирать фрукты для компота.
                        Но&nbsp;вот собирать лимоны на&nbsp;Сицилии для создания органической косметики&nbsp;&mdash; это очень приятный и&nbsp;новый опыт
                    </span>
                </div>
                <div class="article-main">
                    <div class="left">
                        <div class="info">
                            <h3 class="head">
                                Лимонные ароматы Палермо
                            </h3>
                            <span class="desc">
                                Увлекательное видео из&nbsp;биодинамического лимонного сада, цветущего неподалеку от&nbsp;прибрежного сицилийского города.
                            </span>
                            <router-link to="/article2" class="btn" @click.native="gaEvents('main','click','go to longread 2')">
                                Cмотреть
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 87.2 65.2" style="enable-background:new 0 0 87.2 65.2;" xml:space="preserve">
                                    <path class="st0" d="M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2
                                        l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2
                                        c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"/>
                                </svg>
                            </router-link>
                        </div>
                    </div>
                    <div class="right animate-block">
                        <div class="img img1">
                            <img src="static/img/main/article2/front-lem.jpg" alt="">
                        </div>
                        <div class="img img2 delay3">
                            <img src="static/img/main/article2/back-lem.jpg" alt="">
                        </div>
                        <div class="img img3 delay6 animate-img"></div>
                    </div>
                </div>
            </div>
            <div class="article-block article-block3">
                <div class="quotes-img animate-img">
                    <img src="static/img/main/article3/img1.jpg" alt="">
                </div>
                <div class="quotes-img2 animate-img"></div>
                <div class="quotes">
                    <span class="text">
                        Швебиш-Гмюнд&nbsp;&mdash; очень милый небольшой городок с&nbsp;пряничными домиками, в&nbsp;пригороде которого есть сказочный сад
                    </span>
                </div>
                <div class="article-main">
                    <div class="left animate-block">
                        <div class="img img1 ">
                            <img src="static/img/main/article3/front-gr.jpg" alt="">
                        </div>
                        <div class="img img2 delay3">
                            <img src="static/img/main/article3/back-gr.jpg" alt="">
                        </div>
                    </div>
                    <div class="right">
                        <div class="info">
                            <h3 class="head">
                                Природная гармония в Швебиш-Гмюнде
                            </h3>
                            <span class="desc">
                                Уникальный сад, где цветут тысячи лекарственных растений, которые используются в&nbsp;производстве натуральной косметики.
                            </span>
                            <router-link to="/article3" class="btn" @click.native="gaEvents('main','click','go to longread 3')">
                                Cмотреть
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 87.2 65.2" style="enable-background:new 0 0 87.2 65.2;" xml:space="preserve">
                                    <path class="st0" d="M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2
                                        l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2
                                        c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"/>
                                </svg>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Helpers from '@/tools/Helpers';
    export default {
        name: 'pageMain',
        methods:{
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// pageMain.vue?a4446790